import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import { Col, Text, Row, useDynamicResponsiveValue } from 'react-quick-style-components';
import { ChartMultiple } from '../index';
import { VarHelper } from 'helpers';
import { ASSETS, COLOR, fSize, ICON, SCREEN_NAME } from 'const';
import { useNavFunc } from 'navigation';
import Store from 'store';
import PortfolioValueChart from './PortfolioValueChart';
import RegionChart from './RegionChart';
import DistilleryChart from './DistilleryChart';
import CustomTrilogyChart from './CustomTrilogyChart';
import MyPlanOther from './MyPlanOther';

const TAB = {
  PORTFOLIO_VALUE: 'PORTFOLIO',
  REGIONS: 'REGIONS',
  DISTILLERIES: 'DISTILLERIES',
  // OTHER: 'STRATEGY',
}

const StrategyComponent = forwardRef((props, ref) => {
  const [{}, cApi] = Store.Client.createStore();
  const [listAllClients, setListAllClients] = useState([]);
  const [regionPieChartData, setRegionPieChartData] = useState([]);
  const [portfolioPieChartData, setPortfolioPieChartData] = useState([]);
  const [distilleryPieChartData, setDistilleryPieChartData] = useState([]);
  const [activeTab, setActiveTab] = useState(TAB.PORTFOLIO_VALUE);
  const [chartTypeData, setChartTypeData] = useState([]);

  console.log('regionPieChartData', regionPieChartData);
  console.log('portfolioPieChartData', portfolioPieChartData);
  console.log('distilleryPieChartData', distilleryPieChartData);
  console.log('listAllClients', listAllClients);

  useEffect(() => {
    const getData = async () => {
      const [res, err] = await cApi.getListAllClients();
      if (err) {
        console.log(err);
        return;
      }
      if (!!res) {
        // console.log('RES LENGTH', res.length);
        const indiviualRecords = [];
        res.forEach(val => {
         if (Array.isArray(val)) {
          val.forEach(item => {
            indiviualRecords.push(item);
          });
         } else {
          indiviualRecords.push(val);
         }
        });
        setListAllClients(indiviualRecords);
        setRegionPieChartData(
          cApi.makeRegionPieChartData(indiviualRecords, null)
        );
        setPortfolioPieChartData(
          cApi.makeRegionPorfolioChartData(indiviualRecords, null)
        );
        setDistilleryPieChartData(
          cApi.makeDistilleryChartData(indiviualRecords, null)
        );
      }
    };
    getData();
  }, []);

  const tabArr = Object.keys(TAB).map(val => TAB[val]);

  useImperativeHandle(ref, () => ({
    setActiveTab,
  }));

  const customTrilogyChartType = chartTypeData.find(val => (val.Name || '').toUpperCase() === activeTab);
  // console.info('customTrilogyChartType', customTrilogyChartType);

  return (
    <Col>
      <Row style={{ flexWrap: 'wrap' }} borderBottomWidth1 borderBottomColor='rgba(0,0,0,0.2)'>
        {tabArr.map(val => (
          <Col
            key={val} paddingRight20 paddingVertical5
            onPress={val === activeTab ? undefined : () => setActiveTab(val)}
          >
            <Text
              fontSize20 lineHeight26
              fontFamily={ val === activeTab ? 'PlayfairDisplay_600SemiBold' :
                'PlayfairDisplay_400Regular'
              }
            >{val}</Text>
          </Col>
        ))}
        {!!chartTypeData && Array.isArray(chartTypeData) && chartTypeData.map((val, valI) => {
          const name = (val.Name || '').toUpperCase();
          return (
            <Col
              key={'customTrilogi-'+name+valI} paddingHorizontal10 paddingVertical5
              onPress={name === activeTab ? undefined : () => setActiveTab(name)}
            >
              <Text bold={name === activeTab} fontFamily='PlayfairDisplay_400Regular'>{name}</Text>
            </Col>
          );
        })}
      </Row>
      {activeTab === TAB.PORTFOLIO_VALUE ? <PortfolioValueChart data={portfolioPieChartData} />
      : activeTab === TAB.REGIONS ? <RegionChart data={regionPieChartData} />
      : activeTab === TAB.DISTILLERIES ? <DistilleryChart data={distilleryPieChartData} />
      : null
      }

    </Col>
  );
});

export default StrategyComponent;